module.exports = __webpack_public_path__ + "img/video-mask.5e72ad05.png";